import { Anchor, Header, Nav, Image, Button } from "grommet";
import { Home, Previous } from "grommet-icons";
import { useState, useEffect } from "react";
import ConfirmPopupWindow from "./ConfirmPopupWindow";
import { useNavigate } from "react-router-dom";
import { calculateHeight } from "../Utils/Utils";

const HomePageNav = (props) => {
     // State to manage whether the confirmation popup is open
    const [open, setOpen] = useState(false);

    // State to track which navigation button was clicked (previous or home)
    const [navigateTo, setNavigateTo] = useState(""); // Track which button was clicked
 
    // React Router's navigation hook to programmatically navigate between routes
    const navigate = useNavigate();
    
    // console.log('In HomePageNav props obj:', props);

    /**
     * Handles navigation button clicks.
     * If there are unsaved changes (indicated by `props.hasEdit`), it opens a confirmation popup.
     * Otherwise, it proceeds directly with navigation.
     * @param {Event} event - The click event from the navigation button.
     * @param {string} destination - The destination to navigate to ("previous" or "home").
     */
    const onOpen = (event, destination) => {
        event.preventDefault();
        setNavigateTo(destination);

        if (props.hasEdit) {
            setOpen(true);  // Show confirmation popup if there are unsaved changes
        } else {
            proceedWithNavigation(destination); // Proceed without confirmation
        }
    };

    // Closes the confirmation popup and proceeds with navigation.
    const onClose = () => {
        setOpen(false);
        proceedWithNavigation(navigateTo);
    };

    // Get the current page path (e.g., "home", "postharvest")
    const pathname = window.location.pathname //returns the current url minus the domain name
    // console.log("In  HomePageNav pathname:" + pathname);

    const currentPage = pathname.slice(1);
    // console.log("In  HomePageNav currentPage:" + currentPage);

    /**
     * Handles the confirmation action from the popup.
     * Saves any unsaved changes before proceeding with navigation.
     */
    const onConfirm = async () => {
        onClose();
        if (props.save !== undefined) {
            await props.save();
        }
        
        proceedWithNavigation(navigateTo);
    };

        /**
     * Navigates to the specified destination.
     * - "previous" navigates back to the previous screen based on the current page.
     * - "home" navigates to the home page.
     * @param {string} destination - The destination to navigate to ("previous" or "home").
     */
    const proceedWithNavigation = (destination) => {
        if (destination === "previous") {
            returnToScreen();   // Return to the previous screen
        } else if (destination === "home") {
            navigate("/", { state: { refresh: true } });     // Navigate to home page with a refresh state
        }
    };

    /**
     * Handles navigation back to the appropriate screen based on the current page.
     * Different screens are handled with different navigation logic.
     */
    const returnToScreen = () => {
        // console.log ('In return');
        if (currentPage === "postharvest") {
            // console.log ('return from postharvest');
            // console.log ('props.setSelectedField >> ', props.setSelectedField);
            // console.log ('props.station  >>  ', props.station);
            // console.log ('props.stationIDOption  >>  ', props.stationIDOption);
                    
            navigate('/eval-sheet', { 
                state:{
                    fromAnotherScreen: true, 
                    newExist: "ExistingEvaluation", 
                    selectedStation: props.station,
                    plantInfo: props.plantInfo,         // for EvaluationSheet screen 
                    chosenOption: "Stations",
                    activeStationsList: props.activeStationsList,
                    chosenVineInfo: props.plantInfo,    // for ExistingEvaluation screen               
                    showScionOnField: (props.plantInfo !== null && props.plantInfo.IsSeedling === 1) ? false : true,
                } 
            })
        }
        else if (currentPage === "treatment") {
            // console.log('In HomePageNav props obj:', props);
                 
            navigate('/eval-sheet', { 
                state:{
                    fromAnotherScreen: true,
   //                 selectedStation: props.station,
                    plantInfo: props.plantInfo,         // for EvaluationSheet screen 
                    chosenOption: "Stations",
                    activeStationsList: props.activeStationsList,
                    selectedStation: props.station,
                    chosenVineInfo: props.plantInfo,    // for ExistingEvaluation screen 
                    showTreatments: props.showTreatments,
                    showEvaluationForTreatment: props.showEvaluationForTreatment,
                    showMultiYearSummary: props.showMultiYearSummary,
                    showTreatmentsMultiYearSummary: props.showTreatmentsMultiYearSummary,
                } 
            })
        }
        else if (currentPage === "preharvest") {
            // console.log('In HomePageNav props obj:', props); 
            navigate('/eval-sheet', { 
                state:{
                    fromAnotherScreen: true, 
                    newExist: "ExistingEvaluation", 
                    plantInfo: props.plantInfo,         // for EvaluationSheet screen 
                    chosenOption: props.plantInfo !== null && props.plantInfo.IsSeedling === 1 ? "Seedlings" : "Stations",
                    seedlingId: props.seedlingId,
                    seedlingYear: props.seedlingYear,
                    seedlingRow: props.seedlingRow,
                    seedlingsArr: props.seedlingsArr,
                    selectedStation: props.plantInfo !== null && props.plantInfo.IsSeedling === 1 ? "" : props.station,
                    activeStationsList: props.plantInfo !== null && props.plantInfo.IsSeedling === 1 ? [] : props.activeStationsList,
                    chosenVineInfo: props.plantInfo,    // for ExistingEvaluation screen               
                    showSeedlingOnField: props.plantInfo !== null && props.plantInfo.IsSeedling === 1 ? true : false,
                    showScionOnField: false,
                    showTreatments: props.showTreatments,
                    showEvaluationForTreatment: props.showEvaluationForTreatment,
                    showMultiYearSummary: props.showMultiYearSummary,
                    showTreatmentsMultiYearSummary: props.showTreatmentsMultiYearSummary,

                } 
            }
        )}
        // TemplateTreatmentsPage
        else if (currentPage === "st-treatment") {                
            navigate('/eval-manager');
        }
        // CultivarsManagementPage
        else if (currentPage === "cult-manager") {
            navigate('/eval-manager' );
        }
        // VineyardsManagementPage
        else if (currentPage === "fields-manager") {
            navigate('/eval-manager' );
        }
       // UserManagementPage
        else if (currentPage === "user-manager") {
            navigate('/eval-manager' );
        }                  
        else if (currentPage === "eval-sheet") {
            navigate('/manager' );
        }
    }

  return (
    <Header direction="row" height={calculateHeight(5)} width="100px" justify="around" >
        <Nav direction="row" gap="medium"  alignSelf="center">
            {(currentPage !== "eval-sheet") && (currentPage !== "queries") && (currentPage !== "eval-manager") &&
            <Anchor pad={{ vertical: "none" }}  alig="center" onClick={(event) => onOpen(event, "previous")}>
                <Previous color='white' size='medium'/> 
            </Anchor> }                                          
            <Anchor href="/" pad={{ vertical: "none" }} alignself="center" onClick={(event) => onOpen(event, "home")}>
                <Home color='white' size='medium' /> 
            </Anchor>
            {open && (
                <ConfirmPopupWindow
                msg={"Unsaved changes. Do you want to save?"}
                onClose={onClose}
                onConfirm={onConfirm}
                ></ConfirmPopupWindow>
            )}
        </Nav>
    </Header>
  );
};

export default HomePageNav;
